module.exports = __webpack_public_path__ + "static/media/logo11.373970d8.png";